import { apiGet, apiPost, apiPut, apiDelete, apiPatch, apiPostWithMultiPart } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export default {

  // Get all ICD codes with pagination
  getIcdCodesList: (size=0, current=1, searchInput="") => apiGet(domainUrl(`/v1/icd-codes?limit=${size}&page=${current}&code=${searchInput}`)),

  // Get a specific ICD code by ID
  getIcdCodeById: (id) => apiGet(domainUrl(`/v1/icd-codes/${id}`)),

  // Create new ICD codes
  createIcdCodes: (payload) => apiPost(domainUrl(`/v1/icd-codes`), payload),

  // Update an existing ICD code
  updateIcdCodes: (id, payload) => apiPut(domainUrl(`/v1/icd-codes/${id}`), payload),

  // Delete ICD codes
  deleteIcdCodes: (payload) => apiPost(domainUrl(`/v1/icd-codes/delete`), payload),

  // Preview import ICD codes
  previewImportIcdCodes: (payload) => apiPostWithMultiPart(domainUrl(`/v1/icd-codes/preview-import`), payload),
};